import { Injectable, Injector } from "@angular/core";
import { AfterOrganisationInitialisation } from "../organisation/after-organisation-initialisation.decorator";
import { BaseOrganisationService } from "../organisation/base-organisation.service";
import { CulturalLeadershipQueryUtilities } from "./cultural-leadership-query-utilities";

export const SupportingMemberTooltip = "The cultural leader is not directly responsible for facilitating or scheduling cultural measurements for this person. They can still view and record cultural measurements for this person";
export const CulturalCohortTooltip = "Members for whom you are responsible for facilitating and scheduling cultural measurements";

@Injectable({
    providedIn: "root",
})
export class OrgCommonCulturalLeadershipService extends BaseOrganisationService {
    private clQueryUtilities = new CulturalLeadershipQueryUtilities(this.commonDataService);

    public constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    @AfterOrganisationInitialisation
    public async promiseToGetCulturalLeadershipConfiguration() { // leave async here even if there is no away as the function becomes a promise from the decorator
        return this.clQueryUtilities.promiseToGetCulturalLeadershipConfiguration();
    }
}
